const url = 'https://api.bible-ministries.com';
export default url;
